import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const DashboardRouter = () => {
  const role = String(localStorage.getItem('role') || '').toUpperCase();

  if (role === 'SUPER ADMIN') {
    return <Navigate to='/superAdmin' replace />;
  }

  if (role === 'ADMIN') {
    return <Navigate to='/Hub' replace />;
  }

  if (role === 'SECURITY') {
    return <Navigate to='/security-dashboard' replace />;
  }

  return <Navigate to='/user-dashboard' replace />;
};

export default DashboardRouter;
